export default {
    WEIGHT: ['кг', 'т'],
    VOLUME: ['см³', 'м³'],
};



// WEBPACK FOOTER //
// ./client/lang/ru/units.js